import {
  CREATEDEVICEBATCH,
  CREATEDEVICEBATCH_SUCCESS,
  UPDATEDEVICEBATCH,
  UPDATEDEVICEBATCH_SUCCESS,
  FETCHDEVICEBATCHS,
  FETCHDEVICEBATCHS_SUCCESS,
  DELETEDEVICEBATCH,
  DELETEDEVICEBATCH_SUCCESS,
  ONBOARDDEVICEBATCH,
  ONBOARDDEVICEBATCH_SUCCESS,
  FETCHDEVICEBATCH,
  FETCHDEVICEBATCH_SUCCESS
} from "constants/ActionTypes";

export const fetchDeviceBatchs = () => {
  console.log('fetchDeviceBatchs');
  return {
    type: FETCHDEVICEBATCHS,
    payload: {
    }
  };
};

export const fetchDeviceBatchsSuccess = (deviceBatchs, applicationId) => {
  console.log('fetchDeviceBatchsSuccess', deviceBatchs);

  return {
    type: FETCHDEVICEBATCHS_SUCCESS,
    payload: deviceBatchs
  };
};

export const fetchDeviceBatch = (serial) => {
  console.log('fetchDeviceBatch');
  return {
    type: FETCHDEVICEBATCH,
    payload: {
      serial: serial
    }
  };
};

export const fetchDeviceBatchSuccess = (deviceBatch) => {
  console.log('fetchDeviceBatchSuccess', deviceBatch);

  return {
    type: FETCHDEVICEBATCH_SUCCESS,
    payload: deviceBatch
  };
};

export const createDeviceBatch = (creatingDeviceBatch) => {
  console.log('creatingDeviceBatch', creatingDeviceBatch)
  return {
    type: CREATEDEVICEBATCH,
    payload: creatingDeviceBatch
  };
};

export const createDeviceBatchSuccess = (createdDeviceBatch) => {

  return {
    type: CREATEDEVICEBATCH_SUCCESS,
    payload: createdDeviceBatch
  };
};

export const updateDeviceBatch = (updatingDeviceBatch) => {
  console.log('updatingDeviceBatch', updatingDeviceBatch)
  return {
    type: UPDATEDEVICEBATCH,
    payload: updatingDeviceBatch
  };
};

export const updateDeviceBatchSuccess = (updatedDeviceBatch) => {
  console.log('updatedDeviceBatch', updatedDeviceBatch)

  return {
    type: UPDATEDEVICEBATCH_SUCCESS,
    payload: updatedDeviceBatch
  };
};

export const onboardDeviceBatch = (deviceBatch) => {
  console.log('onboardDeviceBatch', deviceBatch)
  return {
    type: ONBOARDDEVICEBATCH,
    payload: deviceBatch
  };
};

export const onboardDeviceBatchSuccess = (deviceBatch) => {
  console.log('onboardDeviceBatchSuccess', deviceBatch)

  return {
    type: ONBOARDDEVICEBATCH_SUCCESS,
    payload: deviceBatch
  };
};

export const deleteDeviceBatch = (deletingDeviceBatch) => {

  return {
    type: DELETEDEVICEBATCH,
    payload: deletingDeviceBatch
  };
};

export const deleteDeviceBatchSuccess = (deletedDeviceBatch) => {

  return {
    type: DELETEDEVICEBATCH_SUCCESS,
    payload: deletedDeviceBatch
  };
};
